'use client';

import { useModalDrawerContext } from '../../common/components/ModalDrawerContext/ModalDrawerContext';
import { FilledExclamationMark } from '../../common/svgIcons/FilledExclamationMark';
import { useIsBelowScreenWidth } from '../../layouts/utils/useIsBelowScreenWidth';
import { SummaryInfoDrawer } from './SummaryInfoDrawer';
import { AcceptOrderTranslations } from './getTranslations';

interface SummaryInfoProps {
  translations: AcceptOrderTranslations;
  title: string;
  subtitle1: string;
  subtitle2: string;
}

export const SummaryInfo = ({
  translations,
  title,
  subtitle1,
  subtitle2,
}: SummaryInfoProps) => {
  const { openDrawer, close } = useModalDrawerContext();

  const isMobile = useIsBelowScreenWidth(1024);

  return (
    <FilledExclamationMark
      data-element="button"
      size={24}
      onClick={() =>
        openDrawer(SummaryInfoDrawer, {
          position: isMobile ? 'bottom' : 'right',
          customTitle: title,
          translations,
          subtitle1,
          subtitle2,
          onClose: () => {
            close();
          },
        })
      }
    />
  );
};
